import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, eyebrow, children }) {
  return (
    <main className="bg-white text-[#0A0A0A] min-h-screen font-body">
      <header className="border-b border-black/10 bg-white">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
          <Link
            to="/"
            className="font-display font-black tracking-tighter text-xl md:text-2xl flex items-center gap-2"
            data-testid="legal-logo-link"
          >
            <span className="inline-block w-2 h-2 bg-[#D30000]" />
            MHorgas<span className="text-[#D30000]">Consult</span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium hover-marker"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={16} /> Zurück
          </Link>
        </div>
      </header>

      <section className="px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-12">
        <div className="max-w-[840px] mx-auto">
          <div className="overline mb-4">{eyebrow}</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95]">
            {title}
          </h1>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-16 pb-24">
        <div className="max-w-[840px] mx-auto legal-content space-y-10">
          {children}
        </div>
      </section>

      <footer className="border-t border-black/10 bg-[#0A0A0A] text-white">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/60">
          <div>© {new Date().getFullYear()} Michael Horgas Consult. Alle Rechte vorbehalten.</div>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
            <Link to="/" className="hover:text-white transition-colors">Startseite</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
